<template>
  <div>
    <h2>Памятка по работе с seo-текстами для клиента Demis Group</h2>

    <p>Как известно, на динамику роста запросов в поисковых системах большое влияние оказывает контентное наполнение сайта. По утверждениям представителей поисковой системы Яндекс: «Основное предназначение поисковой системы Яндекс – отвечать на вопросы. Если Ваш сайт может лучше других ответить на вопрос пользователя, вероятность, что именно он займет первое место в результатах поиска по соответствующему поисковому запросу, будет максимальна». Таким образом, можно с уверенностью заявить, что сайт, предоставляющий наиболее полный ответ на запрос пользователя, будет ранжироваться выше в результатах поиска. Если посетитель находит ответ на интересующий его вопрос на сайте и проводит на нем достаточно времени, поисковый алгоритм дает высокую оценку сайту по поведенческим факторам. Кроме того, получив исчерпывающий ответ на свой вопрос, посетители не уйдут на сайты Ваших конкурентов. В рамках договора мы перерабатываем и оптимизируем существующие на сайте тексты, но если их нет, то несмотря на увеличение затрат, мы создаем контент «с нуля». Необходимо, чтобы эта работа была совместной, так как Вы лучше всего разбираетесь в особенностях Вашего бизнеса, товарах и услугах. Написание правильных с точки зрения поисковых систем и продающих текстов – это результат командной работы по созданию совершенного контента. Компания Demis Group всегда стремится к повышению качества обслуживания своих партнеров и клиентов, именно поэтому мы тщательно анализируем все внутренние бизнес-процессы Компании. Учитывая специфику Вашего бизнеса, мы предлагаем множество вариантов решения для успешного контентного развития и наполнения сайта:</p>

    <c-box class="variants">
      <div
        v-for="(variant, index) of variants"
        :key="index"
        class="variant"
      >
        <div class="variant-img">
          <img
            v-if="variant.img"
            :src="require(`../../../img/faq/aboutseotext/${variant.img}`)"
            :alt="variant.img"
          >
        </div>
        <div class="variant-content">
          <div class="variant-title">
            {{ variant.title }}
          </div>
          <div
            class="variant-text"
            v-html="variant.text"
          />
        </div>
        <div class="clearfix" />
      </div>
    </c-box>

    <h3>Наши преимущества</h3>

    <p>За годы работы на рынке SEO-продвижения мы разработали и внедрили различные эффективные схемы взаимодействия при написании текстов. Учитывая этот опыт, мы с уверенностью можем сказать, что неразрешимых ситуаций не бывает, а залог успеха заключен в тесном сотрудничестве. Самое главное - это достижение результата и удовлетворенность наших клиентов и партнеров.</p>

    <div
      class="text-center"
      style="padding: 20px;"
    >
      <img
        src="../../../img/faq/aboutseotext/advantages.png"
        alt="advantages"
        style="max-width: 700px; width: 100%;"
      >
    </div>

    <h3>Эффективность нашей работы подтверждается результатами</h3>

    <div
      class="text-center"
      style="padding: 20px;"
    >
      <img
        src="../../../img/faq/aboutseotext/cases.jpg"
        alt="cases"
        style="max-width: 700px; width: 100%;"
      >
    </div>

    <h3>Отзывы наших клиентов</h3>

    <c-box
      title="ООО «Атекс» (novasport.ru)"
      header-background-variant="danger"
      header-text-color-variant="light"
    >
      Особого упоминания заслуживает контент, который готовят специалисты Demis Group. Видно, что тексты написаны профессионалами, которые разбираются в тематике. Кроме того, тексты составлены грамотно, без каких-то грамматических ошибок. Рекомендуем компанию Demis Group для поискового продвижения Вашего сайта!
    </c-box>

    <c-box
      title="Юридическое Бюро «Табула Лекс» (urlegat.ru)"
      header-background-variant="danger"
      header-text-color-variant="light"
    >
      Отдельно хотелось бы отметить работу с контентом: хорошие, качественные тексты, предоставляемые специалистами «Demis Group», способствовали эффективному поисковому продвижению нашего сайта. Видно, что контентом занимаются люди, которые понимают специфику темы, на которую пишут. Спасибо за эффективную работу и прекрасный результат!
    </c-box>

    <p class="text-center">
      <a
        href="/doc/seo-text.pdf"
        class="text-danger"
      >Скачать pdf</a>
    </p>
  </div>
</template>

<script>
import CBox from '../../components/ui/CBox'

export default {
  name: 'AboutSeoText',
  components: {
    CBox
  },
  data () {
    return {
      variants: [
        {
          img: 'record.png',
          title: 'Телефонные переговоры в режиме записи',
          text: 'Если в рамках работы над созданием и переработкой текстов, не удается достигнуть желаемого результата, мы готовы в режиме телефонного звонка подробно обсудить все тексты, принять Ваши комментарии и пожелания. Данный звонок будет зафиксирован, записан и передан в отдел контентной оптимизации специалистам, которые непосредственно занимаются созданием контента для Вашего сайта.'
        },
        {
          img: 'hands.png',
          title: 'ТЗ для создания текста',
          text: 'Никто не знает всех тонкостей и деталей лучше, чем владельцы бизнеса, те, кто создают или производят товары или услуги. Если у Вас есть специалисты по маркетингу, копирайтер в штате, максимально эффективным будет наше взаимодействие с ними. Оптимизаторы подготовят техническое задание согласно SEO-требованиям, а Ваши специалисты, учитывая данные требования, могут написать учитывающие специфику Вашего бизнеса тексты. Наши специалисты обязательно их проверят и предложат правки, если это потребуется.'
        },
        {
          img: 'hands-with-keyboard.png',
          title: 'Агентство по копирайтингу',
          text: 'Мы готовы предложить услуги наших партнеров – студий профессионального копирайтинга, которые создают маркетинговые тексты. В данном случае мы предоставляем техническое задание с учетом требований SEO-оптимизации специалистам студий. На основании этого технического задания копирайтеры-маркетологи напишут тексты одновременно и продающие, и учитывающие требования поисковой оптимизации. Обратите внимание: услуги студии оплачиваются отдельно. Контакты студий Вы можете запросить у Вашего персонального менеджера.'
        },
        {
          img: 'man.png',
          title: 'Копирайтер на выбор',
          text: 'Мы обладаем штатом копирайтеров по различным тематикам, с разными стилями и подходами к составлению текста. Поэтому если текущие тексты Вас не устраивают, мы готовы предложить Вам написание тестового текста несколькими специалистами для выбора Вашего постоянного копирайтера, в текстах которого лучше учтена специфика Вашего бизнеса.'
        },
        {
          img: 'skype.png',
          title: 'Скайп-конференция',
          text: 'Если у Вас есть желание сообщить нам максимум информации о своем бизнесе, если в рамках работ требуется большое количество текстов, мы организуем скайп-конференцию или конференц-звонок, где Вы сможете познакомиться с рабочей группой по написанию контента и озвучить все пожелания к составлению текстов аккаунт-менеджеру, оптимизатору и копирайтеру лично.'
        },
        {
          img: 'man2.png',
          title: 'Копирайтер-маркетолог',
          text: 'У нас есть уникальная услуга – создание текстов с учетом маркетинговой направленности и SEO-требований. Копирайтер-маркетолог создаст контент, который будет соответствовать Вашим высоким стандартам и требованиям поисковой оптимизации сайта. Но поскольку условиями договора не предусмотрено написание маркетинговых текстов, стоимость работы данного специалиста не входит в стоимость договора на продвижение сайта. Если Вы планируете воспользоваться услугами копирайтера–маркетолога, сообщите о своем решении аккаунт-менеджеру. После оплаты согласованного счета специалист приступит к работе.'
        },
        {
          img: 'hands2.png',
          title: 'Взаимодействие с редактором',
          text: 'Если у Вас узкоспециализированная тематика, специфичные товары или услуги, описание которых требует наличия дополнительной информации, мы предлагаем сотрудничество с редактором-копирайтером. Редактор позвонит Вам и выслушает все Ваши пожелания и дополнения к созданию или переработке текста. Вы сможете вносить изменения в тексты совместно с редактором, , который контролирует их качество и соответствие поставленным задачам.'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.variants {
  margin: 20px 0;

  & div:last-child {
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .variant {
    border-bottom: 1px solid $textGrayColor;
    padding-bottom: 20px;
    margin-bottom: 20px;

    .variant-img {
      float: left;
      width: 100px;

      @media (max-width: $xsBreakpoint) {
        float: none;
        margin: 0 auto;
      }

      img {
        height: auto;
        width: 100%;
      }
    }

    .variant-content {
      margin-left: 120px;

      @media (max-width: $xsBreakpoint) {
        margin-left: 0;
      }

      .variant-title {
        color: $textDangerColor;
        font-weight: bold;
        font-size: 20px;
        padding-top: 7px;
      }

      .variant-text {

      }
    }
  }
}
</style>
